<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import IconStop from '@/presentation/components/icons/IconStop.vue';

const { t } = useI18n();
</script>

<template>
    <button
        class="lab-border-rounded-lg th-btn th-btn-text absolute bottom-10 !pl-5 !pr-[28px]"
        data-size="lg"
    >
        <IconStop class="th-btn-icon mr-1 h-6 w-6 fill-primary" />

        {{ t('aiTranslation.stopGenerate') }}
    </button>
</template>
